var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2400 2400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M104.2,154.8l71.3-84.4C227.5,6.8,320.5-4,385.6,46l531,407.2c103.3,78.2,123.7,225.3,45.5,328.5             c-1.4,1.8-2.8,3.6-4.2,5.4L941,809.6c-76.9,95.7-131.3,258.9-41.3,343.4l424,394c114.5,106.9,223.3-48.8,335.9-152             c73.2-72.7,191.4-72.7,264.6,0l405.3,405.3c206.4,206.4-122,546-334,583.5c-128.9,9.5-257.2-24.9-364-97.6             c-410.8-222.3-781.8-511.4-1097.6-855.6C248.7,1115.5-194.1,603.2,104.2,154.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.53629b211fd21ea26dc9c38ece65abb9.svg";
export { ForwardRef as ReactComponent };